<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        Convert SSH Key to PPK format
      </gg-toolbar>

      <v-card-text>
        <template v-if="!ppk">
          <p>Enter the passphrase to unlock the “{{ sshKey.name }}” key for conversion:</p>
          <gg-text-field
            v-model="pass"
            label="Passphrase"
            name="Passphrase"
            v-validate="'required'"
            :error-messages="errors.collect('Passphrase')"
          />
        </template>
        <template v-else>
          <p>Convert the “{{ sshKey.name }}” key to PPK format:</p>
          <v-textarea outlined rows="7" readonly :value="ppk"></v-textarea>
        </template>
      </v-card-text>
      <v-card-actions class="pt-0 justify-content-end">
        <gg-btn secondary class="mb-0 ml-0" @click="close">Cancel</gg-btn>
        <gg-btn
          v-if="!ppk"
          :loading="loading"
          class="mb-0"
          @click="convert"
        >
          Convert
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ConvertToPpkModal',
  mixins: [modalMixin],
  props: {
    sshKey: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      ppk: null,
      pass: '',
    }
  },
  methods: {
    ...mapActions(['convertToPpkHostingSshKey', 'reportError', 'reportSuccess']),
    async convert () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      const name = this.sshKey.name
      const pass = this.pass
      try {
        const response = await this.convertToPpkHostingSshKey({ name, pass })
        this.ppk = response[0].key
        this.reportSuccess(`The key “${this.sshKey.name}” has been converted.`)
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
